import { fork, all } from 'redux-saga/effects';

// import all sagas

//user
import * as s_getLoggedUser from './user/s_getLoggedUser';

// licenze
import * as s_getLicenses from './licenze/s_getLicenses';
import * as s_saveLicense from './licenze/s_saveLicense';

import * as s_editDataScadenzaLicense from './licenze/s_editDataScadenzaLicense';
import * as s_blockLicense from './licenze/s_blockLicense';
import * as s_unblockLicense from './licenze/s_unblockLicense';
import * as s_unlinkLicense from './licenze/s_unlinkLicense';

import * as s_getCodiceModuli from './licenze/s_getCodiceModuli';
import * as s_setAllActive from './licenze/s_setAllActive';
import * as s_setCodiceModuli from './licenze/s_setCodiceModuli';
import * as s_insertModuli from './licenze/s_insertModuli';

import * as s_setSerialNumberOld from './licenze/s_setSerialNumberOld';

import * as s_getLicenseDetails from './licenze/s_getLicenseDetails';

import * as s_editLicense from './licenze/s_editLicense';

import * as s_initializeNewLicenseData from './licenze/s_initializeNewLicenseData';
import * as s_getCodiciUtente from './licenze/s_getCodiciUtente';
import * as s_genPK from './licenze/s_genPK';
import * as s_genSN from './licenze/s_genSN';
import * as s_checkSN from './licenze/s_checkSN';
import * as s_isSerialOldUsed from './licenze/s_isSerialOldUsed';

//statistiche
import * as s_getStatistiche from './statistiche/s_getStatistiche';

//log 
import * as s_getLogAccessi from './log/s_getLogAccessi';
import * as s_getLogLicenze from './log/s_getLogLicenze';

//email
import * as s_sendLicenseDetails from './email/s_sendLicenseDetails';

export default function* rootSaga() {
    yield all([
        // user
        fork(s_getLoggedUser.triggerAction),

        // licenze
        fork(s_getLicenses.triggerAction),
        fork(s_saveLicense.triggerAction),

        fork(s_editDataScadenzaLicense.triggerAction),
        fork(s_blockLicense.triggerAction),
        fork(s_unblockLicense.triggerAction),
        fork(s_unlinkLicense.triggerAction),

        fork(s_getLicenseDetails.triggerAction),

        fork(s_editLicense.triggerAction),


        // moduli
        fork(s_getCodiceModuli.triggerAction),
        fork(s_setAllActive.triggerAction),
        fork(s_setCodiceModuli.triggerAction),
        fork(s_insertModuli.triggerAction),
        fork(s_setSerialNumberOld.triggerAction),

        // dati licenze
        fork(s_initializeNewLicenseData.triggerAction),
        fork(s_getCodiciUtente.triggerAction),
        fork(s_genPK.triggerAction),
        fork(s_genSN.triggerAction),
        fork(s_checkSN.triggerAction),
        fork(s_isSerialOldUsed.triggerAction),

        //statistiche
        fork(s_getStatistiche.triggerAction),

        //log 
        fork(s_getLogAccessi.triggerAction),
        fork(s_getLogLicenze.triggerAction),

        //email
        fork(s_sendLicenseDetails.triggerAction),


    ]);
}

export {
    // user
    s_getLoggedUser,

    // licenze
    s_getLicenses,
    s_saveLicense,

    s_editDataScadenzaLicense,
    s_blockLicense,
    s_unblockLicense,
    s_unlinkLicense,

    s_getCodiceModuli,
    s_setAllActive,
    s_setCodiceModuli,
    s_insertModuli,
    s_setSerialNumberOld,

    s_getLicenseDetails,

    s_editLicense,

    //dati licenze
    s_initializeNewLicenseData,
    s_getCodiciUtente,
    s_genPK,
    s_genSN,
    s_checkSN,
    s_isSerialOldUsed,


    //statistiche
    s_getStatistiche,

    //log
    s_getLogAccessi,
    s_getLogLicenze,

    //email
    s_sendLicenseDetails,

};
